import { makeStyles, shorthands } from "../shared";

export const helpMenuButtonStyles = makeStyles({
  root: {
    minWidth: "0",
    ...shorthands.margin("0px"),
    ...shorthands.padding("0px"),
  },
});
